/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CarrierInvoiceApprovalMethod {
  Automated = "automated",
  Manual = "manual",
}

export function instanceOfCarrierInvoiceApprovalMethod(value: any): boolean {
  for (const key in CarrierInvoiceApprovalMethod) {
    if (
      Object.prototype.hasOwnProperty.call(CarrierInvoiceApprovalMethod, key)
    ) {
      if (
        CarrierInvoiceApprovalMethod[
          key as keyof typeof CarrierInvoiceApprovalMethod
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CarrierInvoiceApprovalMethodFromJSON(
  json: any,
): CarrierInvoiceApprovalMethod {
  return CarrierInvoiceApprovalMethodFromJSONTyped(json, false);
}

export function CarrierInvoiceApprovalMethodFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceApprovalMethod {
  return json as CarrierInvoiceApprovalMethod;
}

export function CarrierInvoiceApprovalMethodToJSON(
  value?: CarrierInvoiceApprovalMethod | null,
): any {
  return value as any;
}

export function CarrierInvoiceApprovalMethodToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CarrierInvoiceApprovalMethod {
  return value as CarrierInvoiceApprovalMethod;
}
